export const Button = ({ label, type, onClick }) => {
    return (
        <button
            className="mt-5 w-full rounded-md bg-blue-500 py-3 px-5 border border-transparent text-center text-[15px] font-bold text-white transition-all shadow-md hover:shadow-lg focus:bg-blue-700 focus:shadow-none active:bg-blue-700 hover:bg-blue-700 active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type={type}
            onClick={() => onClick()}
        >
            {label}
        </button>
    );
};
